import { useMutation } from '@apollo/client'
import { unflagUser as unflagUserGql } from 'src/graphql/mutations/unflagUser.gql'

const useUnflagUser = (mutationHookOptions) => {
   const [unflagUser, { called, client, data, error, loading }] =
      useMutation(unflagUserGql, mutationHookOptions)

   const wrappedMutationFn = (filter, input, mutationFnOptions) => unflagUser({
      variables: { ...filter, input },
      ...mutationFnOptions
   })

   return {
      unflagUser: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useUnflagUser
